import apiClient from "../../../services/apiClient";
import "./ResetPasswordConfirm.scss";
import React, { useEffect, useRef } from "react";
import {
  NavigateFunction,
  useNavigate,
  useSearchParams,
} from "react-router-dom";
import { toast } from "react-toastify";

const _submit = (
  token: string | undefined,
  password: string,
  navigate: NavigateFunction
) => {
  apiClient
    .post("auth/password/reset/confirm", {
      token,
      password,
    })
    .then((_) => {
      toast.success("Modification de mot de passe réussie. Vous pouvez maintenant vous connecter avec votre nouveau mot de passe.", {
        className: "toast-success",
      });
      navigate("/");
    })
    .catch((err) => {
      if (process.env.NODE_ENV !== "production") {
        console.error(err);
      }
      toast.error("Une erreur est survenue.", {
        className: "toast-error",
      });
    });
};

const ResetPasswordConfirm = () => {
  const newPassword = useRef() as React.MutableRefObject<HTMLInputElement>;
  const confirmNewPassword =
    useRef() as React.MutableRefObject<HTMLInputElement>;
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const token = searchParams.get("token");

  useEffect(() => {
    if (!token) {
      navigate("/");
    }
  }, [navigate, token]);

  return (
    <div id="reset-password-confirm">
      {token && (
        <React.Fragment>
          <h2>Réinitialisation de votre mot de passe</h2>
          <form
            onSubmit={($event) => {
              $event.preventDefault();
              if (
                newPassword.current.value !== confirmNewPassword.current.value
              ) {
                alert("Vos mots de passe doivent correspondre.");
              } else {
                _submit(token, newPassword.current.value, navigate);
              }
            }}
          >
            <input
              type="password"
              name="new-password"
              placeholder="Votre nouveau mot de passe"
              ref={newPassword}
              autoCapitalize="off"
              autoCorrect="off"
              tabIndex={1}
              autoFocus
              minLength={6}
            />
            <input
              type="password"
              name="new-password-confirm"
              placeholder="Confirmer votre nouveau mot de passe"
              ref={confirmNewPassword}
              autoCapitalize="off"
              autoCorrect="off"
              tabIndex={2}
              minLength={6}
            />
            <input type="submit" value="Confirmer" tabIndex={3} />
          </form>
        </React.Fragment>
      )}
    </div>
  );
};

export default ResetPasswordConfirm;
